import { Link } from 'react-router-dom';

/**
 * 100% PARITY VERSION: Replicating Angular boostingyourlifestyle-footer exactly
 */
export function Footer() {
    const currentYear = new Date().getFullYear();

    const footerLinks = {
        shopOnline: [
            { label: 'Fitness Products', link: '/materials' },
            { label: 'Delivery & Returns', link: '/shipping' },
            { label: 'Exchange & Refunds', link: '/returns' },
            { label: 'Order Tracking', link: '/tracking' },
            { label: 'FAQs', link: '/faq' }
        ],
        information: [
            { label: 'How To Buy Fitness', link: '/how-to-buy' },
            { label: 'Terms & Conditions', link: '/terms' },
            { label: 'Privacy Policy', link: '/privacy' },
            { label: 'Shipping Policy', link: '/shipping-policy' },
            { label: 'Disclaimer', link: '/disclaimer' }
        ]
    };

    const locations = {
        headOffice: {
            title: 'Boosting Your Lifestyle Head Office',
            address: 'Your Address Here',
            tel: '+92 ...',
            email: 'hello@boostingyourlifestyle.shop'
        },
        fourSeasons: {
            title: 'Boosting Your Lifestyle Support',
            address: 'Online Support',
            tel: '+92 ...',
            email: 'support@boostingyourlifestyle.shop'
        }
    };

    return (
        <footer className="bg-white text-gray-800">
            {/* Main Footer Content */}
            <div className="py-16 md:py-20 lg:pb-12 border-b border-gray-50">
                <div className="max-w-[1600px] mx-auto px-4 md:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-y-12 gap-x-12">

                        {/* Brand Column */}
                        <div className="lg:pr-8">
                            <div className="mb-6">
                                <h2 className="text-3xl font-bold tracking-tight text-gray-900"
                                    style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
                                    BOOSTING YOUR LIFESTYLE
                                </h2>
                            </div>
                            <p className="text-gray-600 mb-8 leading-relaxed text-[15px]">
                                Lorem ipsum dolor sit amet, conse elit, sedid do eiusmod tempor incidi ut labore et dolore.
                            </p>

                            {/* Contact & Social row */}
                            <div className="flex flex-wrap items-center gap-4">
                                <Link to="/contact-us"
                                    className="inline-block bg-[#D4AF37] hover:bg-[#C5A028] text-white font-semibold px-6 py-2.5 rounded-md transition-all duration-300 shadow-sm text-sm">
                                    Contact Us
                                </Link>

                                <div className="flex gap-2">
                                    {[
                                        { icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
                                        { icon: 'M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.84 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z' },
                                        { icon: 'M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z' },
                                        { icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' }
                                    ].map((social, i) => (
                                        <a href="#" key={i}
                                            className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#D4AF37] hover:text-white transition-all duration-300 text-gray-600">
                                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                                <path d={social.icon} />
                                            </svg>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Shop Online Column */}
                        <div>
                            <h4 className="text-xl font-bold mb-6 text-gray-900" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
                                Shop Online</h4>
                            <ul className="space-y-4">
                                {footerLinks.shopOnline.map((link) => (
                                    <li key={link.label}>
                                        <Link to={link.link}
                                            className="text-gray-600 hover:text-[#D4AF37] transition-colors text-[15px]">
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Information Column */}
                        <div>
                            <h4 className="text-xl font-bold mb-6 text-gray-900" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
                                Information</h4>
                            <ul className="space-y-4">
                                {footerLinks.information.map((link) => (
                                    <li key={link.label}>
                                        <Link to={link.link}
                                            className="text-gray-600 hover:text-[#D4AF37] transition-colors text-[15px]">
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Head Office Column */}
                        <div>
                            <h4 className="text-xl font-bold mb-6 text-gray-900 leading-tight" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
                                {locations.headOffice.title}
                            </h4>
                            <div className="space-y-5 text-[15px] text-gray-600 leading-relaxed">
                                <p>{locations.headOffice.address}</p>
                                <p><span className="font-bold text-gray-900">Tel:</span> {locations.headOffice.tel}</p>
                                <p><span className="font-bold text-gray-900">Email:</span> <a
                                    href={`mailto:${locations.headOffice.email}`} className="hover:text-[#D4AF37]">{
                                        locations.headOffice.email}</a></p>
                            </div>
                        </div>

                        {/* Four Seasons Column */}
                        <div>
                            <h4 className="text-xl font-bold mb-6 text-gray-900 leading-tight" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
                                {locations.fourSeasons.title}
                            </h4>
                            <div className="space-y-5 text-[15px] text-gray-600 leading-relaxed">
                                <p><span className="font-bold text-gray-900">Office:</span> {locations.fourSeasons.address}</p>
                                <p><span className="font-bold text-gray-900">Tel:</span> {locations.fourSeasons.tel}</p>
                                <p><span className="font-bold text-gray-900">Email:</span> <a
                                    href={`mailto:${locations.fourSeasons.email}`} className="hover:text-[#D4AF37]">{
                                        locations.fourSeasons.email}</a></p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Copyright Bar */}
            <div className="py-8 text-center text-gray-500 text-sm">
                <p>
                    Copyright {currentYear} <span className="text-[#D4AF37] font-medium">Boosting Your Lifestyle.</span> All rights reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;
